import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RootStoreState } from '@app/root-store';
import { DocumentService, UserService } from '@app/shared/services';
import { MobileSideNavService } from '@app/shared/services/mobile-nav/mobile-nav.service';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'discovery-collection-status',
  templateUrl: './collection-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryCollectionStatusComponent implements OnInit, OnDestroy {
  @Input() data;
  @Input() innerContent;
  @Input() Setup_Complete;
  @Input() formAssocationData;

  @Output() previousNextStatusEventEmitter = new EventEmitter<any>();

  text = '';
  formImage = '';
  isFlowMarkedCompleted = false;
  showLoader = true;
  subscription = new Subscription();

  constructor(
    private store$: Store<RootStoreState.State>,
    private _userService: UserService,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private mobileNavService: MobileSideNavService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.Setup_Complete == 'Location_submit') {
      this.subscription.add(
        this.documentService.getformTempletByid(this.data.user_id, this.formAssocationData.associate_vault_user_form_id).subscribe((res) => {
          this.text = res.data.vaultFormData[0].form_name;
          this.formImage = res.data.vaultFormData[0].profile_image_url;
          this.showLoader = false;
          this.cd.detectChanges();
        })
      );
    } else {
      this.showLoader = false;
    }
  }

  updateOnboardingChecklist() {
    if (this.Setup_Complete == 'group_name_sub_Commit') {
      const payload = {
        id: this.data.id,
      };
      this.subscription.add(
        this._userService.CompleteSetupActionGroup(payload).subscribe(
          (res) => {
            this.handleSteps('forward');
          },
          (error: any) => {}
        )
      );
    } else if (this.Setup_Complete == 'Location_submit') {
      this.handleSteps('forward');
    } else {
      const payload = {
        action_group_label: this.data?.group_name,
        user_discovery_path_id: this.data?.user_discovery_path_id,
      };
      this.subscription.add(
        this._userService.completeCollectionGroup(payload).subscribe(
          (res) => {
            this.handleSteps('forward');
            if (res) {
              this.mobileNavService.handleCollection(false);
              this.cd.detectChanges();
              if (res && (res.next_collection_path_id != -1 || res.next_setup_path_id != -1)) {
              }
            }
          },
          (error: any) => {}
        )
      );
    }
  }

  submitAllFormAnswers(event: string | undefined) {
    if (event === 'complete') {
      this.isFlowMarkedCompleted = true;
    } else {
      this.isFlowMarkedCompleted = false;
    }
  }

  handleSteps(event) {
    this.previousNextStatusEventEmitter.emit({ status: event, id: this.data?.id, isFlowMarkedCompleted: this.isFlowMarkedCompleted });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
